import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormBuilder, ValidatorFn, ValidationErrors } from '@angular/forms';
import { CountryCode } from '@ibe.models/country-code.model';
import { SidebarService } from '@ibe/services/ui';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as Actions from '../../../../store/actions/user.actions';
import * as moment from 'moment';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';

import { INDRASignupErrorModalComponent } from 'src/app/components/shared/sidebar-views/signup-error-modal/signup-error-modal.indra.component';
import { INDRASignupErrorEmailModalComponent } from '../signup-error-email-modal/signup-error-email.modal.indra.component';
import * as fromGlobalStore from '@ibe/store/index';
import { INDRACustomerAccountService } from '@ibe.services/customer-account.indra.service';
import { INDRAAuthenticationService } from '@ibe/services';
import * as UserActions from '@ibe/store/actions/user.actions';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { SelectInputOption } from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';
import { HttpClient } from '@angular/common/http';
import { INDRA_US_STATES_URL, INDRA_CA_STATES_URL, INDRA_BR_STATES_URL, INDRA_AU_STATES_CREATE_ACCOUNT_URL, INDRA_AR_STATES_CREATE_ACCOUNT_URL, COUNTRIES_TRANSLATION_KEY } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { ScreenService } from '@ibe/services/ui';
import { INDRADateService } from '@ibe.services/date.indra.service';


type formAvaiable = {
	personal: boolean;
	contact: boolean;
	account: boolean;
	communications: boolean;
	treatment_consent: boolean;
	terms_conditions: boolean;
};

@Component({
	selector: 'app-sign-up',
	templateUrl: './sign-up.indra.component.html',
	styleUrls: ['./sign-up.component.scss']
})
export class INDRASignUpComponent implements OnInit, OnDestroy {

	private isAlive = true;
	treatmentConsent: boolean = undefined;

	formCreate = new FormGroup({});

	triedToSubmit = false;
	formCreateValueOld;
	forms: formAvaiable;
	showCPF: boolean = false;
	socialImported: string = null;
	importError: boolean = false;
	currentYear: number = new Date().getFullYear();
	@ViewChild('sidebar') $sidebar: ElementRef;

	hasChanges$ = Observable.create(observer => {
		this.formCreate.valueChanges.pipe(takeWhile(() => this.isAlive)).subscribe(values => {
			const changes = Object.keys(values).filter(key => values[key] != this.formCreateValueOld[key]);
			observer.next(changes.length > 0);
		});
	});
	consents: string[] = [];
	public countryCodes: any;
	private sub$ = new Subscription();
	countryCodes$: Observable<Array<CountryCode>> = this.store.select(fromStore.getCountryCodes);
	typeOptions: { text: string; value: number; }[];
	titleOptions: { text: string; value: string; }[];
	treatmentConsentOptions: { label: string; selected: boolean; id: string; }[];
	mediaType = 'TP';
	stateCodes = [];
	stateCodesUS = [];
	stateCodesCA = [];
	stateCodesBR = [];
	stateCodesAU = [];
	stateCodesAR = [];
	stateOptions = Array<SelectInputOption>();
	countriesWithStateValues = ['BR', 'CA', 'US', 'AU', 'AR'];
	showStateField = false;
	showErrorMessage: boolean = false;
	showEmailError: boolean = false;
	showFieldError: boolean = false;
	isLoading: boolean = false;
	userInfo: any;
	
	isMobile: boolean = false;
	isMinor: boolean = false;
	countryCodesWithPrefix;

	constructor(
		private sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private pageScrollService: PageScrollService,
		private globalStore: Store<fromGlobalStore.State>,
		private fb: FormBuilder,
		private customerAccountService: INDRACustomerAccountService,
		private authenticationService: INDRAAuthenticationService,
		private storage: INDRAStorageService,
		protected _http: HttpClient,
		@Inject(DOCUMENT) private document: any,
		private ibeAdminService: INDRAIbeAdminService,
		private screen: ScreenService,
		private dateService: INDRADateService,
	) {
		this.createForms();
		this.INDRA_getStateCodes();
		
		this.screen.isMobile().subscribe(value => {
			this.isMobile = value;
		});

		/* NOTE: check if needed
		this.formCreate.statusChanges
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(status => {
				if (status === 'VALID') {
					this.formCreateValueOld = { ...this.formCreate.value };
				}
			});
		*/
	}
	
	ngOnInit() {
		
		// this.formCreateValueOld = { ...this.formCreate.value }; // TODO check if needed
		
		this.sub$.add(
			this.globalStore.select(fromGlobalStore.getSelectedCountryCodesOpts).subscribe(data => {
				if (data && data.length) {
					this.countryCodes = this.INDRA_getCountryCodesOptions(data);
				}
			})
		);

		this.sub$.add(
			this.store.select(fromStore.getCountryCodes).subscribe(data => {
				if (data && data.length) {
					this.countryCodesWithPrefix = this.INDRA_getCountryCodesOptionsPrefix(data)
				}
			})
		)
		

		this.typeOptions = [
			{ text: this.INDRA_getTranslation('createAccountSidebar.text.home'), value: 6 },
			{ text: this.INDRA_getTranslation('createAccountSidebar.text.mobile'), value: 10 },
			{ text: this.INDRA_getTranslation('createAccountSidebar.text.business'), value: 7 }
		];

		this.titleOptions = [
			{ text: this.INDRA_getTranslation('createAccountSidebar.text.mr'), value: 'Mr.' },
			{ text: this.INDRA_getTranslation('createAccountSidebar.text.mrs'), value: 'Mrs.' },
		];

		this.treatmentConsentOptions = [
			{ label: this.INDRA_getTranslation('createAccountSidebar.text.yes'), selected: false, id: 'treatment_consent-yes' },
			{ label: this.INDRA_getTranslation('createAccountSidebar.text.no'), selected: false, id: 'treatment_consent-no' }
		];

	}

	INDRA_getCountryCodesOptions(countryCodes) {
		const options = countryCodes.map(item => ({
			value: item.value,
			text: this.INDRA_getTranslation(item.text)
		}));
		options.sort((a, b) => a.text.localeCompare(b.text));
		return options;
	}
	INDRA_getCountryCodesOptionsPrefix(countryCodes) {
		const options = countryCodes.map(item => ({
			code: item.code,
			name: this.INDRA_getTranslation(COUNTRIES_TRANSLATION_KEY + item.code.toLowerCase()),
			dial_code: item.dial_code
		}));
		options.sort((a, b) => a.name.localeCompare(b.name));
		return options;
	}
	
	createForms() {
		this.formCreate = this.fb.group({
			birthdate: [null, [Validators.required, this.INDRA_checkDateValidity]],
			name_prefix: [null, Validators.required],
			givenName: [null, Validators.required],
			surname: [null, Validators.required],
			nationality: [null, Validators.required],
			phone_prefix: [null, Validators.required],
			phone_type: [null, Validators.required],
			phone_number: [null, Validators.required],
			email: [null, {
				validators: [Validators.required, Validators.email],
				updateOn: 'blur'
			}],
			country: [null, Validators.required],
			city: [null, Validators.required],
			emailResponsibleAdult: [null, {
				validators: [Validators.required, Validators.email],
				updateOn: 'blur'
			}],
			password: [null, [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9]).{8,32}$')]],
			repassword: [null],
			terms_conditions: [null, Validators.required],
			treatment_consent: [null, Validators.required],
			communication_flytap_email: [null],
			communication_flytap_sms: [null],
			communication_milesego_email: [null],
			communication_milesego_sms: [null],
			cpf: [null],
			nif: [null],
			state: [null]
		});

		const MatchPassword = (AC: AbstractControl) => {
			const password = AC.get('password').value;
			const confirmPassword = AC.get('repassword').value;

			if (confirmPassword) {
				if (password != confirmPassword) {
					AC.get('repassword').setErrors({ MatchPassword: true });
				} else {
					AC.get('repassword').setErrors(null);
				}
			} else {
				AC.get('repassword').setErrors({ required: true });
			}
			return null;
		};
		
		this.formCreate.setValidators([MatchPassword, this.INDRA_checkNameLength('givenName','surname')]);
		this.formCreate.controls['email'].setValue(null);
		this.formCreate.controls['password'].setValue(null);


		this.INDRA_formValueChangesUpdateName();
		this.INDRA_formValueChangesUpdateAddress();
	}

	INDRA_getStateCodes(): void {

		const usfilePromise = this._http.get(INDRA_US_STATES_URL).toPromise();
		usfilePromise.then(
			(data: any) => {
				this.stateCodesUS = data;
			},
			err => {
				console.error(err);
			}
		);

		const cafilePromise = this._http.get(INDRA_CA_STATES_URL).toPromise();
		cafilePromise.then(
			(data: any) => {
				this.stateCodesCA = data;
			},
			err => {
				console.error(err);
			}
		);

		const brfilePromise = this._http.get(INDRA_BR_STATES_URL).toPromise();
		brfilePromise.then(
			(data: any) => {
				this.stateCodesBR = data;
			},
			err => {
				console.error(err);
			}
		);

		const aufilePromise = this._http.get(INDRA_AU_STATES_CREATE_ACCOUNT_URL).toPromise();
		aufilePromise.then(
			(data: any) => {
				this.stateCodesAU = data;
			},
			err => {
				console.error(err);
			}
		);

		const arfilePromise = this._http.get(INDRA_AR_STATES_CREATE_ACCOUNT_URL).toPromise();
		arfilePromise.then(
			(data: any) => {
				this.stateCodesAR = data;
			},
			err => {
				console.error(err);
			}
		);
	}

	INDRA_socialMedia(type) {
		this.mediaType = type;
	}
	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
	}

	INDRA_saveSidebar() {
		this.triedToSubmit = true;

		if (this.formCreate.valid) {
			this.validateAllFormFields(this.formCreate);
			this.triedToSubmit = false;

			const formAccessCode = (this.formCreate.controls['phone_prefix'].value).replace(/\s/g, '');
			const accessCode = formAccessCode.replace('+', '');

			this.consents = this.INDRA_getConsents();
			const payload = {
				birthdate: this.formCreate.controls['birthdate'].value,
				personName: {
					namePrefix: this.formCreate.controls['name_prefix'].value,
					givenName: this.formCreate.controls['givenName'].value,
					surname: this.formCreate.controls['surname'].value,
				},
				telephone: {
					countryAccessCode: accessCode,
					phoneLocationType: this.formCreate.controls['phone_type'].value,
					phoneNumber: this.formCreate.controls['phone_number'].value,
				},
				parentalEmail: this.formCreate.controls['emailResponsibleAdult'].value,
				address: {
					countryCode: this.formCreate.controls['country'].value,
					cityName: this.formCreate.controls['city'].value,
					stateProv:  this.formCreate.controls['state'].value,
				},
				cpf:  this.formCreate.controls['cpf'].value,
				nif:  this.formCreate.controls['nif'].value,
				password: this.formCreate.controls['password'].value,
				nationality: this.formCreate.controls['nationality'].value,
				socialMedia: {
					mediaType: this.mediaType,
					email: this.formCreate.controls['email'].value,
				},
				consentsList: this.consents ? this.consents : []
			};

			if (this.formCreate.get('country').value !== 'BR') {
				delete payload['cpf'];
			} else if (this.formCreate.get('country').value === 'BR') {
				payload.cpf = this.formCreate.controls['cpf'].value;
				delete payload['nif'];
			}
			
			if (this.formCreate.get('country').value !== 'PT') {
				delete payload['nif'];
			} else if (this.formCreate.get('country').value === 'PT') {
				payload.nif = this.formCreate.controls['nif'].value;
				delete payload['cpf'];
			}
			this.isLoading = true;
			this.customerAccountService.createCustomerAccount(payload).subscribe(res => {
				if (res && res.status === '200') {
					this.isLoading = false;
					if (res.tapUserProfileBean) {
					const { userProfile, userAddress} = res.tapUserProfileBean;
					const defaultCurrency = res.tapUserProfileBean.defaultCurrency;
						const userData = {
							...userProfile,
							userAddress: userAddress,
							userProfile: userProfile,
							defaultCurrency: defaultCurrency
						};
						
						this.storage.set('userData', userData);
						this.userInfo = { ...userProfile, defaultCurrency};
						this.store.dispatch(new UserActions.PutUserInfoAction(this.userInfo));
						this.closeSidebar();
					}
					this.consents = [];
				} else {
					if (res.errors) {
						this.isLoading = false;
						const error = res.errors[0].desc.split('-');
						if (error[0] && error[0].trim() === 'REPEATED_CUSTOMER_EMAIL') {
							this.showEmailError = true;
						} else {
							this.showEmailError = false;
						}

						if (error[2] && error[2].trim() === 'Invalid Fiscal ID') {
							const errorField = this.formCreate.get('country').value === 'BR' ? 'CPF' : 'NIF';
							this.INDRA_Errors(this.formCreate.controls[errorField.toLowerCase()], errorField, true);
							this.showFieldError = true;
						}
						this.showErrorMessage = true;
						this.INDRA_scrollToError();
					}
				}

			}, error => {
				if (error) {
					this.isLoading = false;
					this.showErrorMessage = true;
				}
			});
		} else {
			this.INDRA_scrollToError();
		}
	}

	INDRA_close(event) {
		if (event) {
			this.showErrorMessage = false;
		}
	}

	INDRA_getConsents() {
		this.consents = [];
		if (this.formCreate.controls['terms_conditions'].value) {
			this.consents.push('LOYTC');
			this.consents.push('TAPPP');
		}
		if (this.formCreate.controls['treatment_consent'].value) {
			this.consents.push('TAPPROF');
		}
		if (this.formCreate.controls['communication_flytap_email'].value) {
			this.consents.push('TAPEMAIL');
		}
		if (this.formCreate.controls['communication_flytap_sms'].value) {
			this.consents.push('TAPSMS');
		}
		if (this.formCreate.controls['communication_milesego_email'].value) {
			this.consents.push('LOYEMAIL');
		}
		if (this.formCreate.controls['communication_milesego_sms'].value) {
			this.consents.push('LOYSMS');
		}
		return this.consents;

	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				// control.markAsTouched({ onlySelf: true });
				control.markAsUntouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			}
		});
	}

	ngOnDestroy() {
		this.isAlive = false;
		this.sub$.unsubscribe();
	}

	/**************************/
	/* Generic functions      */
	/**************************/

	trackByFn(index, item) {
		return index; // or item.id
	}

	/**
	 * Returns list of numbers between a specified interval
	 * @param {number} start number of interval
	 * @param {number} end number of interval
	 * @returns {Array} of interval numbers
	 */
	INDRA_getInterval(start, end, inverted = false) {
		const interval = [];
		for (let i = start; i <= end; i++) {
			interval.push({ text: i, value: i });
		}
		if (inverted) return interval.reverse();
		return interval;
	}

	INDRA_getIntervalYearExpiration() {
		const interval = [];
		const start = moment().format('YYYY');
		const end = moment().add(30, 'years').format('YYYY');

		for (let i = parseFloat(start); i <= parseFloat(end); i++) {
			interval.push({ text: i, value: i });
		}

		return interval;
	}

	/**
	 * Returns class to a formControl if it's not valid
	 * @param {FormControl} formControl to check if has any error
	 * @returns {Object} with matched classes
	 */
	INDRA_hasErrors(control) {
		return control.invalid && this.triedToSubmit;
	}

	INDRA_hasErrorsClasses(control, $event = null) {
		return this.INDRA_hasErrors(control) && this.formCreate.touched ? 'has-error' : '';
	}


	INDRA_Errors(control, field = null, invalid?) {
		const errors = [];
		
		if (Object.is('maxNameCharReached', control)) {
			if (this.formCreate.hasError('maxNameCharReached')) {
				errors.push('bookingDetails.error.createAccMaxNameCharExceeded');
			}
		} else {
			
			if (control.hasError('required')) {
				errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isRequired')}`);
			}
			
			if (control.hasError('invalidDate')) {
				errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isRequired')}`);
			}

			if (control.hasError('email')) {
				errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isNotValid')}`);
			}

			if (control.hasError('MatchPassword')) {
				errors.push(`${this.INDRA_getTranslation('createAccountSidebar.text.passwordNotMatch')}`);
			}

			if (control.hasError('pattern') && field != `${this.INDRA_getTranslation('createAccountSidebar.text.password')}`) {
				errors.push(`${field} ${this.INDRA_getTranslation('createAccountSidebar.text.isNotValid')}`);
			}

			if (control.hasError('pattern') && field == `${this.INDRA_getTranslation('createAccountSidebar.text.password')}`) {
				errors.push(`${this.INDRA_getTranslation('createAccountSidebar.text.mustHaveAtLeast')}`);
			}

			if ((field === 'NIF' || field === 'CPF') && invalid) {
				errors.push(field === 'NIF' ? `${this.INDRA_getTranslation('createAccountSidebar.text.invalidNIF')}` : `${this.INDRA_getTranslation('createAccountSidebar.text.invalidCPF')}`);
			}
		}

		return errors.join('; ');
	}

	INDRA_isInvalid(field) {
		return this.formCreate.controls[field].invalid && this.formCreate.controls[field].dirty;
	}

	INDRA_scrollToError() {
		const sidebar: any = this.$sidebar.nativeElement;
		const sidebarScrollPosition = sidebar.scrollTop;


		setTimeout(() => {
			sidebar.scrollTo({
				left: 0,
				top: !this.showErrorMessage ? (sidebar.querySelector('.input-error').closest('.form-field').getBoundingClientRect().top + sidebarScrollPosition) - 100 : 0,
				behavior: 'smooth'
			});
		}, 100);
	}

	INDRA_formChanges(value?) {
		if (value) {
			this.stateCodes = [];
			this.stateOptions = [];
			if (this.countriesWithStateValues.includes(value)) {
				this.showStateField = true;
				this.formCreate.controls['state'].setValidators(Validators.required);

				switch (value) {
					case 'US':
						this.stateCodes = this.stateCodesUS;
						break;
					case 'CA':
						this.stateCodes = this.stateCodesCA;
						break;
					case 'BR':
						this.stateCodes = this.stateCodesBR;
						break;
					case 'AU':
						this.stateCodes = this.stateCodesAU;
						break;
					case 'AR':
						this.stateCodes = this.stateCodesAR;
						break;
					default:
						break;
				}
				this.formCreate.controls['state'].patchValue(null);

				this.stateCodes.forEach((item) => {
					this.stateOptions.push({
						text: item.state,
						value: item.code
					});
				});
			} else {
				if (this.formCreate.controls['state']) {
					this.formCreate.controls['state'].patchValue(null);
					this.formCreate.controls['state'].clearValidators();
					this.formCreate.controls['state'].updateValueAndValidity();
				}
				this.showStateField = false;
			}
		}

		this.INDRA_handleNationality();
	}
	
	INDRA_checkIfMinor() {
		if (this.formCreate.controls['birthdate'].valid) {
			const birthDate = this.formCreate.controls['birthdate'].value;
			const age = this.dateService.INDRA_computeDifferenceDateOnly(birthDate, new Date().toString()).years();
			if (age < 18) {
				// show and enable emailResponsibleAdult field
				this.isMinor = true;
				this.formCreate.controls['emailResponsibleAdult'].setValidators([Validators.required, Validators.email]);
				return;
			}
		}
		
		// hide and disable emailResponsibleAdult field
		this.isMinor = false;
		this.formCreate.controls['emailResponsibleAdult'].patchValue(null);
		this.formCreate.controls['emailResponsibleAdult'].clearValidators();
		this.formCreate.controls['emailResponsibleAdult'].updateValueAndValidity();
	}
	
	INDRA_withoutDiscount() {
		this.sidebarService.closeSidebar();
		this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
	}

	INDRA_changedTreatmentConsent(event: any) {
		this.treatmentConsent = event === undefined ? undefined : (event === 'treatment_consent-yes' ? true : false);
		this.formCreate.controls['treatment_consent'].setValue(this.treatmentConsent);
	}
	
	
	// TODO: waiting for updates
	TAP_handleSocialImport(socialNetwork) {
		this.socialImported = socialNetwork;
		try {
			if (socialNetwork === 'facebook') {
				this.formCreate.get('firstName').setValue('Mark');
				this.formCreate.get('lastName').setValue('Zuckerberg');
				this.formCreate.get('title').setValue('Mr');
				this.formCreate.get('date_of_birth_year').setValue('1984');
				this.formCreate.get('nationality').setValue('US');
				this.formCreate.get('country').setValue('US');
				this.formCreate.get('email').setValue('mark@facebook.com');
			} else if (socialNetwork === 'google') {
				this.formCreate.get('firstName').setValue('Sundar');
				this.formCreate.get('lastName').setValue('Pichai');
				this.formCreate.get('title').setValue('Mr');
				this.formCreate.get('date_of_birth_year').setValue('1972');
				this.formCreate.get('nationality').setValue('IN');
				this.formCreate.get('country').setValue('IN');
				this.formCreate.get('email').setValue('sundar@google.com');
			}
		} catch (error) { 
			console.error('Error on social import', error);
			this.importError = true;
		}	
	
		this.INDRA_handleNationality();
	}

	INDRA_handleNationality() {
		const nationalitySelected = this.formCreate.get('country').value;

		switch (nationalitySelected) {
			case 'PT':
				this.formCreate.controls['nif'].setValidators([Validators.required]);
				this.formCreate.controls['cpf'].clearValidators();
				this.formCreate.controls['state'].clearValidators();
				break;
			case 'BR':
				this.formCreate.controls['cpf'].setValidators([Validators.required]);
				this.formCreate.controls['nif'].clearValidators();
				this.formCreate.controls['state'].clearValidators();
				break;
			case 'US':
			case 'CA':
				this.formCreate.controls['state'].setValidators([Validators.required]);
				this.formCreate.controls['cpf'].clearValidators();
				this.formCreate.controls['nif'].clearValidators();
				break;
			default:
				this.formCreate.controls['nif'].clearValidators();
				this.formCreate.controls['cpf'].clearValidators();
				this.formCreate.controls['state'].clearValidators();
				break;
		}

		this.formCreate.controls['nif'].updateValueAndValidity();
		this.formCreate.controls['cpf'].updateValueAndValidity();
		this.formCreate.controls['state'].updateValueAndValidity();
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}


	INDRA_formValueChangesUpdateName(){

		this.sub$.add(
			this.formCreate.get('givenName').valueChanges.subscribe((data) => {
				var regex = /^[a-zA-Z0-9_ ]+$/
				var isValid =  regex.test(data);
				if(isValid){
					return;
				} else{
					if(data && data !== this.INDRA_removeSpecialCharacters(data)){
						this.formCreate.controls['givenName'].patchValue(this.INDRA_removeSpecialCharacters(data))
					}
					return;
				}
				
 
			})
		);
		this.sub$.add(
			this.formCreate.get('surname').valueChanges.subscribe((data) => {
				var regex = /^[a-zA-Z0-9_ ]+$/
				var isValid =  regex.test(data);
				if(isValid){
					return;
				} else{
					if(data && data !== this.INDRA_removeSpecialCharacters(data)){
						this.formCreate.controls['surname'].patchValue(this.INDRA_removeSpecialCharacters(data))
					}
					return;
				}
			})
		);
		
		/*
		this.sub$.add(
			this.formCreate.get('birthdate').valueChanges.subscribe((data) => {
				this.INDRA_checkIfMinor();
				return;
			})
		);
		*/
	}
    INDRA_formValueChangesUpdateAddress(){
        this.sub$.add(
        	this.formCreate.get('city').valueChanges.subscribe((data) => {
        		var regex = /^[a-zA-Z0-9_ ]+$/
        		var isValid =  regex.test(data);
        		if(isValid){
        			return;
        		} else{
        		    if(data && data !== this.INDRA_removeSpecialCharacters(data)){
        				this.formCreate.controls['city'].patchValue(this.INDRA_removeSpecialCharacters(data))
        			}
        			return;
        		}


        	})
        );
    }

	INDRA_removeSpecialCharacters(value){
		return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	}
	
	// The total characters for first and last name should not exceed 31 characters
	INDRA_checkNameLength(firstNameControl, secondNameControl): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control.get(firstNameControl).value && control.get(secondNameControl).value) {
				const firstname = control.get(firstNameControl).value.length;
				const lastname = control.get(secondNameControl).value.length;
				if (firstname + lastname > 30) { 
					return { 'maxNameCharReached': true }; 
				} else {
					return null;
				}
			}
		}
	}
	
	INDRA_checkDateValidity(control: AbstractControl): ValidationErrors | null {
		if (control.value) {
			const dateVal = control.value;
			const dateArray = dateVal.split('-');
			if (dateArray.length == 3 && (dateArray[0] === '0' || dateArray[1] === '00' || dateArray[2] === '00')) {
				return { 'invalidDate': true };
			}
		}
		return null;
	}
}
